var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('app-account-choose'),_c('app-Account3-CRUD')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }